export const IS_DEV = !(process.env.NODE_ENV === 'production');
export const EMAIL = 'contact@reactacademy.io';
